export default "__VITE_ASSET__85f67ae6__"